import React from "react";
import { motion } from "framer-motion";
import "./Testimonials.css";
import { useTranslation } from "react-i18next";

const FALLBACK_ITEMS = [
  { name: "Anna Bergström", quote: "Crigo Technologies built our dream website! Their service was smooth and professional." },
  { name: "Jonas Eriksson", quote: "The mobile app they developed exceeded our expectations. Highly recommend!" },
  { name: "Lina Karlsson", quote: "We received amazing IT support and guidance from the Crigo team. They're truly experts." }
];

const Testimonials = () => {
  const { t, i18n } = useTranslation(); // default namespace

  const items = React.useMemo(() => {
    const arr = t("Testimonials.items", { returnObjects: true, defaultValue: [] });
    return Array.isArray(arr) ? arr : [];
  }, [t, i18n.resolvedLanguage]);

  const data = items.length ? items : FALLBACK_ITEMS;

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <motion.h2
          className="testimonials-title"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {t("Testimonials.title", { defaultValue: "What Our Clients Say" })}
        </motion.h2>

        <div className="testimonials-grid">
          {data.map((it, i) => (
            <motion.div
              className="testimonial-card"
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.2 }}
              viewport={{ once: true }}
            >
              <div className="quote-icon">“</div>
              <p className="testimonial-quote">"{it.quote}"</p>
              <p className="testimonial-name">— {it.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;